import { render, staticRenderFns } from "./EmployeeTerminatedListComponent.vue?vue&type=template&id=600ed1be&"
import script from "./EmployeeTerminatedListComponent.vue?vue&type=script&lang=js&"
export * from "./EmployeeTerminatedListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports